<script>
import { services } from '@utils/common-services'
import axios from 'axios'
import { appConfig } from '@src/app.config'
export default {
  beforeMount() {
    this.logout()
  },
  methods: {
    logout() {
      axios.post(appConfig.apiUrl + '/auth/logout', {
        headers: { Authorization: 'JWT ' + services.getAuth() },
      })

      services.logOut()
      this.$router.push({ name: 'login' })
    },
  },
}
</script>
<template>
  <div> </div>
</template>
